<!-- Changer d'onglet ne fait rien glisser : comme dans une app native, l'écran
     change sur place. Seules les pages de détail entrent par la droite. -->
<div class="flex flex-col min-h-screen">
  <div class="flex-grow">
      <router-outlet></router-outlet>
  </div>
  <!-- Bottom Bar -->
  <!-- L'onglet actif se lit dans l'URL, dans la barre elle-même -->
  <vw-app-menu (screenChange)="onScreenChange($event)"></vw-app-menu>
</div>
